import { getOwaRouterRoutesForUnifiedSearch } from './getOwaRouterRoutesForUnifiedSearch';
import { registerRoute } from 'owa-router';

/**
 * Registers all unified search routes for owa-router to support refreshes.
 * @param routeHandlerCallback Callback called on landing directly on any search route
 * @param routeCleanupCallback Callback called on navigating away from the base search route
 */
export const registerSearchRoutes = (
    routeHandlerCallback?: () => void,
    routeCleanupCallback?: () => void
) => {
    const routeCleanup = (
        oldRoute: string[],
        oldParams: any,
        newRoute: string[],
        newParams: any
    ) => {
        if (newRoute[0] !== 'search') {
            // only call cleanup callback if we're exiting the search
            // rest everything should be managed by internal routing
            routeCleanupCallback?.();
        }
        return false;
    };

    getOwaRouterRoutesForUnifiedSearch().forEach(route => {
        registerRoute(route, routeHandlerCallback, routeCleanup);
    });
};
